<template>
    <DCard
        padding
    >
        <div class="mb-5">
            <h4>
                {{ __(`tools.sms.templates.${template}.name`) }}
            </h4>
        </div>
        <DTable
            :items="existingBrandFlavours"
            :fields="fields"
        >
            <template #brand="{item}">
                <td>
                    {{ formatBrandName(item) ?? + ' ' . item.language.text }}
                </td>
            </template>
            <template #action="{item}">
                <td>
                    <div style="display: flex; grid-gap: 10px;">
                        <DButton
                            mini
                            icon="pencil"
                            @click="editFlavour(item)"
                        />
                        <DButton
                            mini
                            icon="trash-can-outline"
                            color="danger"
                            :disabled="item.id === null"
                            @click="openDeleteModal(item)"
                        />
                    </div>
                </td>
            </template>
        </DTable>
        <DFabs>
            <DFab
                id="btn-add"
                icon="plus"
                :label="__('tools.sms.add')"
                @click="addFlavour"
            />
        </DFabs>
        <DModal
            v-if="showDeleteConfirmationModal"
            v-model:show="showDeleteConfirmationModal"
            :title="__('tools.sms.deleteFlavourModal.title')"
            :message="__('tools.sms.deleteFlavourModal.message')"
            is-confirm
            is-error
            @close="closeDeleteModal"
            @confirm="deleteFlavour"
        />
    </DCard>
</template>

<script setup>
import { __ } from '~@/Composables/translation'
import { ref } from 'vue'
import { router } from '@inertiajs/vue3'
import { route } from '~@/Composables/route'

const props = defineProps({
    template: {
        type: String,
        default: null
    },
    existingBrandFlavours: {
        type: Array,
        default: () => { return [] }
    }
})

const fields = [
    { key: 'brand', label: __('tools.sms.table.brand') },
    { key: 'action', label: '' }
]

const showDeleteConfirmationModal = ref(false)
const deleteItem = ref(null)

const addFlavour = () => router.get(route('tools.sms-templates.create', { smsType: props.template }))

function editFlavour (item) {
    const params = {
        smsType: props.template,
        language_code: item.language.value
    }

    if (item.id !== null) {
        params.brand = item.id
    }

    router.get(route('tools.sms-templates.edit', params))
}
function openDeleteModal (item) {
    deleteItem.value = item
    showDeleteConfirmationModal.value = true
}

function closeDeleteModal () {
    deleteItem.value = null
    showDeleteConfirmationModal.value = false
}

function deleteFlavour () {
    router.delete(route('tools.sms-templates.delete', {
        smsType: props.template,
        brand: deleteItem.value.id,
        language_code: deleteItem.value.language.value
    }))
    showDeleteConfirmationModal.value = false
}

function formatBrandName (item) {
    if (item.name === null) {
        return __('tools.sms.default') + ' ' + item.language.text
    }

    return item.language ? item.name + ' ' + item.language.text : item.name
}

</script>
